export const downloadFile = (url: string) => window.location.assign(url);
